// За полной документацией по API, включая примеры кода, зайдите на http://wix.to/94BuAAs
import wixWindow from 'wix-window';
$w.onReady(function () {
	//if(wixWindow.formFactor !== "Mobile"){
	if (wixWindow.multilingual.currentLanguage === "de") {
		$w('#footerDatenSchutzDe').expand();
		$w('#footerDatenSchutzRU').collapse();
	} else {
		$w('#footerDatenSchutzRU').expand();
		$w('#footerDatenSchutzDe').collapse();
	}
	//}
});